export const FAVORITES_COOKIE_NAME = "ms-favorites";

export type FavoriteStore = Record<string, string[]>;

/**
 * Reads the favorites cookie value into listing type → property id lists.
 *
 * @param value - Raw cookie value, percent-encoded or already decoded.
 * @returns Store with string ids only. Empty when the value is missing or invalid.
 */
export function parseFavoriteStore(value: string | undefined): FavoriteStore {
	if (!value?.trim()) return {};

	try {
		const parsed = JSON.parse(decodeURIComponent(value));
		if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

		const store: FavoriteStore = {};

		for (const [listingType, ids] of Object.entries(parsed)) {
			if (!Array.isArray(ids)) continue;

			const favoriteIds = ids.filter((id) => typeof id === "string" && id.length > 0);
			if (favoriteIds.length > 0) store[listingType] = favoriteIds;
		}

		return store;
	} catch {
		return {};
	}
}
